import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { timesheetEndpoints } from '@/lib/api/endpoints';
import { timesheetKeys } from '@/lib/queryKeys';
import type { ApproveTimesheetDto, TimesheetApprovalState } from '@/types/timesheet';

/** Reopen a previously approved period, unlocking its entries. */
export function useReopenTimesheet() {
  const queryClient = useQueryClient();
  return useApiMutation<TimesheetApprovalState, ApproveTimesheetDto>({
    mutationFn: (dto) =>
      apiPost<TimesheetApprovalState, ApproveTimesheetDto>(
        operationsClient,
        timesheetEndpoints.reopen(),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: timesheetKeys.periods() });
      toast.success('Timesheet reopened');
    },
  });
}
